// extracted by mini-css-extract-plugin
module.exports = {"infoText":"infoText_infoText__2KX79"};